<template>
  <div class="transaction-item-info">
    <div
      class="transaction-item-info__item"
      v-if="transaction.recipientAccount.length > 0"
    >
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.account-payments.account') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.recipientAccount }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.account-payments.id') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.account-payments.sum') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.account-payments.recipient-name') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.recipientName }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.account-payments.purpose') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.account-payments.sender-name') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.account-payments.edrpou') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.account-payments.ipn') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemAccountPaymentsInfo',
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
